import React from "react";
import r1 from '../../Images/r1.jpeg';
import r2 from '../../Images/r2.jpg';
import r3 from '../../Images/r3.jfif';
import r4 from '../../Images/r4.jfif';
const Trust = () => {
    return (
        <section className="font-san-francisco relative py-4 md:py-8">
            <div className="companies-that-build-trusts__background"></div>

            <div className="container-wrapper container-wrapper-whole-padding_short max-w-6xl mx-auto flex flex-col gap-10">

                {/* Heading */}

                <h2 className="text-center px-4 mx-auto h2-mb h2-md h2-lg h2-2xl">
                    <span className="text-[#0b2b40]">Für Unternehmen,
                    </span> <br /> denen Vertrauen wichtig ist
                </h2>

                {/* CARDS WRAPPER */}
                <div className="flex flex-col mx-4 md:mx-0 gap-6">

                    {/* FIRST ROW */}
                    <div className="grid grid-cols-12 gap-6">

                        {/* LEFT BIG CARD */}
                        <div className="col-span-12 md:col-span-7 bg-white rounded-2xl border border-[#D5DFE1] overflow-hidden">
                            <img
                                src={r1}
                                className="w-full h-[250px] md:h-[280px] object-cover"
                                alt="Available across all locations"
                            />

                            <div className="p-6">
                                <h5 className="h5-mb h5-md h5-lg h5-2xl">
                                    Für mehr Sichtbarkeit - Standortübergreifend
                                </h5>
                                <p className="text-black/60 text-base md:text-lg leading-relaxed mt-2 ">
                                    Schaffen Sie einen starken, einheitlichen Online-Auftritt – überall, wo Ihr Unternehmen vertreten ist.
                                    Für Marken, die Vertrauen sichtbar machen wollen.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT SMALL CARD */}
                        <div className="col-span-12 md:col-span-5 bg-white rounded-2xl border border-[#D5DFE1] overflow-hidden">
                            <img
                                src={r4}
                                className="w-full h-[250px] md:h-[280px] object-cover"
                                alt="Local trust"
                            />

                            <div className="p-6">
                                 <h5 className="h5-mb h5-md h5-lg h5-2xl">
                                    Kunden vertrauen Bewertungen
                                </h5>
                                <p className="text-black/60 text-base md:text-lg leading-relaxed mt-2">
                                   Zeigen Sie dort Stärke, wo Kund:innen heute zuerst nachsehnen: <strong>Online.</strong>  Ein Überzeugendes Bewertungsprofil schafft Vertrauen und bindet Kund:innen nachhaltig.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* SECOND ROW */}
                    <div className="grid grid-cols-12 gap-6">

                        {/* LEFT SMALL CARD */}
                        <div className="col-span-12 md:col-span-4 bg-white rounded-2xl border border-[#D5DFE1] overflow-hidden">
                            <img
                                src={r3}
                                className="w-full h-[250px] md:h-[280px] object-cover"
                                alt="Payment upon success"
                            />

                            <div className="p-6">
                                 <h5 className="h5-mb h5-md h5-lg h5-2xl">
                                   100% Fairness - Zahlung erst bei Erfolg 
                                </h5>
                                <p className="text-black/60 text-base md:text-lg leading-relaxed mt-2">
                                   Eine Abrechnung erfolgt erst nach erfolgter und bestätigter Löschung der betreffenden 
Bewertungen.  

                                </p>
                            </div>
                        </div>

                        {/* RIGHT BIG CARD */}
                        <div className="col-span-12 md:col-span-8 bg-white rounded-2xl border border-[#D5DFE1] overflow-hidden">
                            <img
                                src={r2}
                                className="w-full h-[250px] md:h-[280px] object-cover"
                                alt="Affordable prices"
                            />

                            <div className="p-6">
                                <h5 className="h5-mb h5-md h5-lg h5-2xl">
                                    Fairer Preis. Große Wirkung. 
                                </h5>
                                <p className="text-black/60 text-base md:text-lg leading-relaxed mt-2">
                                    Mehr Umsatz: Unsere Lösungen verbessern Ihre Sichtbarkeit und Glaubwürdigkeit – und erhöhen so messbar Ihre Kundengewinne.

                                </p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default Trust;
